import client from "api/client";

// F1 — buildApi. Website build-config and the manual "Rebuild now" trigger (F7).

// PUT /websites/{id}/build-config. github_token is write-only — omit it to keep
// the stored token; only include it when the user typed a new one.
export const updateBuildConfig = async (websiteId, payload) => {
  const body = { ...payload };
  if (!body.github_token) delete body.github_token;
  const { data } = await client.put(`/websites/${websiteId}/build-config`, body);
  return data;
};

export const triggerBuild = async (websiteId) => {
  const { data } = await client.post(`/websites/${websiteId}/trigger-build`);
  return data;
};
